import script from "./EnvioListComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnvioListComponent.vue?vue&type=script&setup=true&lang=ts"

import "./EnvioListComponent.vue?vue&type=style&index=0&id=bf5c6d8a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf5c6d8a"]])

export default __exports__